module.exports = __webpack_public_path__ + "img/folder-gray.d9501113.svg";